<template>
  <div>
    <v-btn color="accent" large @click.stop="addItem">
      Open Modal
    </v-btn>
    <v-btn color="accent" large @click.stop="editItem">
      Edit Modal
    </v-btn>
    <v-btn color="accent" large @click.stop="editEmail">
      Email Modal
    </v-btn>
    <v-btn color="accent" large @click.stop="editCommittee">
      Comm Modal
    </v-btn>
    <UserForm
      :visible="showAnimalForm"
      :item="item"
      :isEdit="isEdit"
      @close="closeThis"
    />
    <EmailForm
      :visible="showEmailForm"
      :items="items"
      :selectedItems="selectedItems"
      @close="closeThis"
    />
    <CommitteeForm
      :visible="showCommitteeForm"
      :item="item1"
      :isEdit="isEdit"
      @close="closeThis"
    />
  </div>
</template>

<script>
import UserForm from './forms/UserForm'
import EmailForm from './forms/EmailForm'
import CommitteeForm from './forms/CommitteeForm'

export default {
  components: {
    UserForm,
    EmailForm,
    CommitteeForm
  },

  data () {
    return {
      showAnimalForm: false,
      showEmailForm: false,
      showCommitteeForm: false,
      isEdit: false,
      item: {
        id: 298,
        firstName: 'William',
        middle: 'P',
        lastName: 'Worthog',
        email: 'tgardner@changecompanies.net',
        password: '',
        image: '',
        picture: 'http://localhost:8081/images/11-Crocodile.jpg',
        imageFile: '11-Crocodile.jpg',
        address1: '123 Main St.',
        city: 'Carson City',
        state: 'NV',
        zip: '89551',
        homePhone: '(775) 555-1111',
        cellPhone: '(775) 555-2222',
        workPhone: '(775) 555-3333',
        status: 'active',
        startDate: 1984,
        birthDate: '1969-10-13',
        handBook: 0,
        notes: 'Now is the time for all good men to come to the aid of their party.'
      },
      items: [
        'John Doe <john@doe.com>',
        'Jane Doe <jane@doe.com>',
        'Jim Doe <jim@doe.com>',
        'Robert Johnson <robertjohnson@gmail.com>'
      ],
      item1: {
        id: 1,
        name: 'Test Comm',
        code: 'TC',
        byLaws: false,
        active: true,
        year: 2019,
        ExecGroupId: 85,
        parentId: 462,
        notes: 'Now is the time for all good men to come to the aid of their party.'
      },
      selectedItems: [
        'John Doe <john@doe.com>',
        'Jim Doe <jim@doe.com>'
      ]
    }
  },

  methods: {
    addItem () {
      this.isEdit = false
      this.showAnimalForm = true
    },
    editItem () {
      this.isEdit = true
      this.showAnimalForm = true
    },
    editCommittee () {
      this.isEdit = true
      this.showCommitteeForm = true
    },
    editEmail () {
      this.showEmailForm = true
    },
    closeThis (item) {
      this.showAnimalForm = false
      this.showEmailForm = false
      this.showCommitteeForm = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Table4.vue